var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "custom-fieldset" },
    [
      _c(
        "legend",
        [
          _vm._v(" " + _vm._s(_vm.$t("report.chosenDelegations")) + " "),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          { staticClass: "ml-2", attrs: { small: "" } },
                          on
                        ),
                        [_vm._v("info")]
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("report.onlySettledDelegationsTooltip")) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.criteria.search,
                  callback: function($$v) {
                    _vm.$set(_vm.criteria, "search", $$v)
                  },
                  expression: "criteria.search"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.$t("global.dateSpanType"),
                  items: _vm.dateSpanTypes
                },
                model: {
                  value: _vm.criteria.date_span_type,
                  callback: function($$v) {
                    _vm.$set(_vm.criteria, "date_span_type", $$v)
                  },
                  expression: "criteria.date_span_type"
                }
              })
            ],
            1
          ),
          _vm.criteria.date_span_type ===
          _vm.dateSpanTypesConst.DATE_SPAN_TYPE_MONTHLY
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: _vm.$t("global.month"),
                      items: _vm.availableMonths
                    },
                    model: {
                      value: _vm.criteria.month,
                      callback: function($$v) {
                        _vm.$set(_vm.criteria, "month", $$v)
                      },
                      expression: "criteria.month"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.criteria.date_span_type ===
          _vm.dateSpanTypesConst.DATE_SPAN_TYPE_QUARTERLY
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: _vm.$t("global.quarter"),
                      items: _vm.availableQuarters
                    },
                    model: {
                      value: _vm.criteria.quarter,
                      callback: function($$v) {
                        _vm.$set(_vm.criteria, "quarter", $$v)
                      },
                      expression: "criteria.quarter"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          [
            _vm.dateSpanTypesConst.DATE_SPAN_TYPE_MONTHLY,
            _vm.dateSpanTypesConst.DATE_SPAN_TYPE_QUARTERLY,
            _vm.dateSpanTypesConst.DATE_SPAN_TYPE_YEARLY
          ].includes(_vm.criteria.date_span_type)
            ? _c(
                "v-col",
                {
                  staticClass: "px-2",
                  attrs: {
                    md2:
                      _vm.criteria.date_span_type !==
                      _vm.dateSpanTypesConst.DATE_SPAN_TYPE_YEARLY,
                    md4:
                      _vm.criteria.date_span_type ===
                      _vm.dateSpanTypesConst.DATE_SPAN_TYPE_YEARLY,
                    cols: "12"
                  }
                },
                [
                  _c("v-select", {
                    attrs: {
                      label: _vm.$t("global.year"),
                      items: _vm.availableYears
                    },
                    model: {
                      value: _vm.criteria.year,
                      callback: function($$v) {
                        _vm.$set(_vm.criteria, "year", $$v)
                      },
                      expression: "criteria.year"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.criteria.date_span_type === 1
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
                [
                  _c("date-picker", {
                    attrs: {
                      clearable: true,
                      label: _vm.$t("report.delegationReportForm.fromDate"),
                      model: _vm.criteria.from_date,
                      placeholder: _vm.$t("global.all")
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(_vm.criteria, "from_date", $event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.criteria.date_span_type === 1
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
                [
                  _c("date-picker", {
                    attrs: {
                      clearable: true,
                      label: _vm.$t("report.delegationReportForm.toDate"),
                      model: _vm.criteria.to_date,
                      placeholder: _vm.$t("global.all")
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(_vm.criteria, "to_date", $event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.dateTypeNames,
                  label: _vm.$t("report.delegationReportForm.dateType")
                },
                model: {
                  value: _vm.criteria.date_type,
                  callback: function($$v) {
                    _vm.$set(_vm.criteria, "date_type", $$v)
                  },
                  expression: "criteria.date_type"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.users,
                  label: _vm.$t("delegation.form.fields.delegated.name"),
                  "item-text": "full_name",
                  "item-value": "id",
                  clearable: "",
                  multiple: "",
                  placeholder: _vm.$t("global.all")
                },
                model: {
                  value: _vm.criteria.user_ids,
                  callback: function($$v) {
                    _vm.$set(_vm.criteria, "user_ids", $$v)
                  },
                  expression: "criteria.user_ids"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.costCentres,
                  label: _vm.$t("global.costCentre"),
                  clearable: "",
                  multiple: "",
                  "item-text": "name",
                  "item-value": "id",
                  placeholder: _vm.$t("global.all")
                },
                model: {
                  value: _vm.criteria.cost_centre_ids,
                  callback: function($$v) {
                    _vm.$set(_vm.criteria, "cost_centre_ids", $$v)
                  },
                  expression: "criteria.cost_centre_ids"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "2", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.organizationStructures,
                  label: _vm.$t("global.organizationStructure"),
                  clearable: "",
                  multiple: "",
                  "item-text": "name",
                  "item-value": "id",
                  placeholder: _vm.$t("global.all")
                },
                model: {
                  value: _vm.criteria.organization_structure_ids,
                  callback: function($$v) {
                    _vm.$set(_vm.criteria, "organization_structure_ids", $$v)
                  },
                  expression: "criteria.organization_structure_ids"
                }
              })
            ],
            1
          ),
          _vm.isReInvoicingForExternalContractorModuleEnabled
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { cols: "12", md: "2" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.externalCustomers,
                      label: _vm.$t(
                        "delegation.form.fields.externalCustomer.name"
                      ),
                      clearable: "",
                      "item-text": "name",
                      "item-value": "id",
                      placeholder: _vm.$t("global.all")
                    },
                    model: {
                      value: _vm.criteria.external_customer_id,
                      callback: function($$v) {
                        _vm.$set(_vm.criteria, "external_customer_id", $$v)
                      },
                      expression: "criteria.external_customer_id"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isReInvoicingForExternalContractorModuleEnabled
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { cols: "12", md: "2" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      hint:
                        typeof _vm.projects.find(function(v) {
                          return v.value === _vm.criteria.project_id
                        }) === "undefined"
                          ? ""
                          : _vm.$t("global.orderNumber") +
                            ": " +
                            _vm.projects.find(function(v) {
                              return v.value === _vm.criteria.project_id
                            }).order_number,
                      items: _vm.projectsForExternalCustomer,
                      label: _vm.$t("delegation.form.fields.project.name"),
                      "item-text": "name",
                      "item-value": "id",
                      clearable: "",
                      "persistent-hint": "",
                      placeholder: _vm.$t("global.all")
                    },
                    model: {
                      value: _vm.criteria.project_id,
                      callback: function($$v) {
                        _vm.$set(_vm.criteria, "project_id", $$v)
                      },
                      expression: "criteria.project_id"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-checkbox", {
        attrs: { label: _vm.$t("report.allByCriteria") },
        model: {
          value: _vm.criteria.allByCriteria,
          callback: function($$v) {
            _vm.$set(_vm.criteria, "allByCriteria", $$v)
          },
          expression: "criteria.allByCriteria"
        }
      }),
      _vm.criteria.allByCriteria === false
        ? _c("v-data-table", {
            attrs: {
              "custom-filter": _vm.filterOverAllProperty,
              search: _vm.criteria.search,
              headers: _vm.headers,
              items: _vm.filteredDelegations,
              loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
              "item-key": "id",
              "show-select": ""
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c(
                        "td",
                        [
                          _c("v-checkbox", {
                            attrs: {
                              "hide-details": "",
                              primary: "",
                              value: props.isSelected
                            },
                            on: { change: props.select }
                          })
                        ],
                        1
                      ),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(" " + _vm._s(props.item.number) + " ")
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(" " + _vm._s(props.item.userFullname) + " ")
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("global.fromDateShort")) + " "
                        ),
                        _c("b", { staticClass: "text-no-wrap" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                props.item.start_date,
                                "YYYY-MM-DD"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          " " + _vm._s(_vm.$t("global.toDateShort")) + " "
                        ),
                        _c("b", { staticClass: "text-no-wrap" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                props.item.end_date,
                                "YYYY-MM-DD"
                              )
                            )
                          )
                        ])
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _c("b", { staticClass: "text-no-wrap" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                props.item.accepted_at,
                                "YYYY-MM-DD"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", { staticClass: "smaller-name" }, [
                          _vm._v(_vm._s(props.item.accepted_by_name))
                        ])
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _c("b", { staticClass: "text-no-wrap" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                props.item.settled_at,
                                "YYYY-MM-DD"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", { staticClass: "smaller-name" }, [
                          _vm._v(_vm._s(props.item.settled_by_name))
                        ])
                      ]),
                      _c("td", [
                        _vm._v(
                          " " +
                            _vm._s(
                              props.item.external_customer_name
                                ? props.item.external_customer_name
                                : ""
                            ) +
                            " " +
                            _vm._s(
                              props.item.project_name
                                ? props.item.project_name
                                : ""
                            ) +
                            " " +
                            _vm._s(
                              props.item.order_number
                                ? props.item.order_number
                                : ""
                            ) +
                            " "
                        )
                      ]),
                      _c(
                        "td",
                        [_vm._t("action", null, { item: props.item })],
                        2
                      )
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.selectedDelegations,
              callback: function($$v) {
                _vm.selectedDelegations = $$v
              },
              expression: "selectedDelegations"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }